(function () {
	// Also when loaded after the DOM is ready (the join loads Joinchat on the first user interaction).
	const onReady = (callback) => {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', callback);
		} else {
			callback();
		}
	};

	onReady(() => {
		if (!window.jQuery || !window.joinchat_obj) {
			return;
		}

		const $ = window.jQuery;

		function trackEvent(action, label = '', value = null) {
			const eventCategory = window.joinchat_obj.settings?.event_category || 'Joinchat';

			const data = {
				event_category: eventCategory,
				event_action: action,
				event_label: label,
				is_mobile: window.joinchat_obj.is_mobile ? 'yes' : 'no',
				page_location: location.href,
				page_title: document.title || 'no title',
			};

			if (value !== null) {
				data.event_value = value;
			}

			VgGtm.pushRegisterEventToDataLayer('joinchat_event', {}, data);
		}

		// Chat window opened
		$(document).on('joinchat:show', () => {
			trackEvent('chat_open');
		});

		// Chat window closed
		$(document).on('joinchat:hide', () => {
			trackEvent('chat_close');
		});

		// Chat Funnels addon / contact options shown (funnel reached its end)
		$(document).on('joinchat:can_contact', () => {
			trackEvent('contact_show');
		});

		// Chat Funnels addon / user clicks a funnel option (goto/link/contact).
		// Joinchat doesn't dispatch an event for this, so we read the DOM element directly.
		document.addEventListener('click', (event) => {
			const option = event.target.closest('.joinchat__option');
			if (!option) {
				return;
			}

			const type = [...option.classList]
				.find((className) => className.startsWith('joinchat__option--'))
				?.replace('joinchat__option--', '') || 'unknown';

			trackEvent(`option_${type}`, option.textContent.trim());
		});

		// Opt-in checkbox toggled. Joinchat doesn't dispatch an event for this either.
		document.addEventListener('change', (event) => {
			if (event.target.id !== 'joinchat_optin') {
				return;
			}

			trackEvent('optin_toggle', event.target.checked ? 'accept' : 'reject');
		});

		// Support Agents addon / online agents computed
		$(document).on('joinchat:agents', (event, agents) => {
			const total = Array.isArray(agents) ? agents.length : 0;
			const online = Array.isArray(agents) ? agents.filter((agent) => agent.online).length : 0;
			trackEvent('agents_loaded', `${online}/${total} online`, online);
		});
	});
})();
